import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/webpractik/web/prod.webpractik.ru.w6p.ru/releases/67/components/features/cases/OldComponents/cases/rec/index.js");
